export default "__VITE_ASSET__47a7b098__"